import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { Burger, Cross } from "../shared/Icon";
import sections from "../shared/sections";

const HeaderElement = styled.header`
  z-index: 100;
  position: fixed;
  padding: 5vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (${(props) => props.theme.breakpoint}) {
    padding: 5vh 5vw;
  }
`;

const Nav = styled.nav`
  svg {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
    transition: transform 300ms;
  }
  &:hover {
    svg {
      transform: rotate(90deg);
    }
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  border: 0;
  padding: 0;
  color: #fff;
  text-align: left;
  background: transparent;
  cursor: pointer;
`;

const Availablity = styled.div`
  display: flex;
  flex-direction: column;
  span {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
    font-weight: 700;
    margin-bottom: 0.2rem;
  }
  a {
    color: #fff;
    text-decoration: none;
    font-size: 0.8rem;
    line-height: 0.8rem;
    opacity: 0.8;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Header = ({ currentSection, onClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderElement>
        <Nav>
          <Button onClick={onClick}>
            {sections[currentSection].number === "000" ? <Cross /> : <Burger />}
          </Button>
        </Nav>

        {sections[currentSection].number !== "000" && (
          <Availablity>
            <span>{t("Header.available")}</span>
            <a href="mailto:hello@dorianguilmain.com">
              hello@dorianguilmain.com
            </a>
          </Availablity>
        )}
      </HeaderElement>
    </>
  );
};

export default Header;
